import {MidiDeviceHolder} from "./MidiDeviceHolder";
import {MidiDeviceCategory} from "./Midi";
import {MidiMessage} from "./MidiMessage";

export {MidiRouter}

class MidiRouter {

    public static routeToAllPhysicalOutputs(midiEvent: MidiMessage, outputs: Array<MidiDeviceHolder>) {
        outputs.forEach((output) => {
            if (output.category === MidiDeviceCategory.Physical) {
                output.send(midiEvent.midiEvent.data);
            }
        });
    }

    public static routeToAllOutputs(midiMessage: MidiMessage, outputs: Array<MidiDeviceHolder>) {
        outputs.forEach((output) => {
            if(midiMessage.source.name !== output.name) {
                output.send(midiMessage.midiEvent.data);
            }
        });
    }
}